import React, {Fragment, useState, useEffect, useContext} from 'react'

import {StorageContext} from '../../context'

import Overlooked from '../../overlooked'
import SimilarProducts from '../../similar-products'
import ProductCard from '../../product-card'
import BreadCrumbs from '../../bread-crumbs'

const ProductCardDesktop = ({match}) => {
  const storage = useContext(StorageContext);
  const {params} = match;

  const
    [title, setTitle] = useState(),
    [categoryId, setCategoryId] = useState(),
    [categoryTitle, setCategoryTitle] = useState(),
    [filters, setFilters] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);

    const viewed = storage.getViewed();
    const index = viewed.indexOf(params.id);

    if (index === -1) {
      viewed.push(params.id);

      if (viewed.length > 10) {
        viewed.shift()
      }
    }

    storage.setViewed(viewed);

  }, [params.id]);

  return (
    <Fragment>
      <BreadCrumbs path={[
        {title: categoryTitle, link: {pathname: '/catalogue', state: {category: categoryId}}},
        {
          title: filters && filters.type, link: {
            pathname: '/catalogue',
            state: {category: categoryId, filter: {filterName: 'typeFilter', value: filters && filters.type}}
          }
        },
        {title: title}
      ]}/>
      <ProductCard params={params && params.id}
                   categoryId={categoryId}
                   setCategoryId={setCategoryId}
                   setCategoryTitle={setCategoryTitle}
                   setTitle={setTitle}
                   setFilters={setFilters}/>
      <Overlooked />
      <SimilarProducts id={params.id}
                       params={filters ? `type=${encodeURIComponent(filters.type)}&color=${encodeURIComponent(filters.color)}` : null}/>
    </Fragment>
  )
};

export default ProductCardDesktop
